export const NOTIFICATION_SETTINGS_SUCCESS = "NOTIFICATION_SETTINGS_SUCCESS";

export const NOTIFICATION_LOADER_VISIBILITY = "NOTIFICATION_LOADER_VISIBILITY";
export const NOTIFICATION_PULL_REFRESH_VISIBILITY = "NOTIFICATION_PULL_REFRESH_VISIBILITY";

export const NOTFICATION_LIST_SUCCESS = "NOTFICATION_LIST_SUCCESS";
export const FETCH_MORE_NOTFICATION_LIST_SUCCESS = "FETCH_MORE_NOTFICATION_LIST_SUCCESS";

export const SET_NOTIFICATION_UNREAD_COUNT = "SET_NOTIFICATION_UNREAD_COUNT"

export const MARK_READ_ALL_NOTIFICATION = "MARK_READ_ALL_NOTIFICATION"